const LangChanger = (ln, eng, bn) => {
    return ln !== 'English'? eng : bn
};

export default LangChanger;